import {
	selectAppStateDepolSurveyId,
	selectAppStatePrimaryChartId,
	selectAppStatePrimarySurveyId,
	selectAppStateThreshold,
	selectAppStateUseThreshold,
	selectAppStateUseShadow,
	selectAppStateRemediationActions,
	selectAppStateCustomGroups,
	selectAppStateUseInterpolatedDepol,
	selectAppStateUseNormalizedDepol,
	selectAppStateSeriesVisibility
} from '../redux/_reusable/ScanAppAndReportStates/AppStateV2/selectors';
import { thunkComputeBelowCriterions } from '../redux/AppAnalysisPage/slices/Charts/slices/ChartsBelowCriterions/actions';
import {
	setRemediationsActions,
	thunkClearCustomGroupRanges,
	thunkSetCustomGroupRanges
} from '../redux/_reusable/ScanAppAndReportStates/ChartsRemediations/actions';
import { addChartSettings } from '../redux/AppAnalysisPage/slices/Charts/slices/ChartsSettings/actions';
import { createInitialChartSettings } from '../redux/AppAnalysisPage/slices/Charts/slices/ChartsSettings/util';
import { selectDataXYMinMax } from '../redux/AppAnalysisPage/slices/StoreXYMinMax/selectors';

export const loadChartSettings = (dispatch, getState) => {
	const stateApp = getState().app;

	const chartId = selectAppStatePrimaryChartId(stateApp);
	const primarySurveyId = selectAppStatePrimarySurveyId(stateApp);
	const depolSurveyId = selectAppStateDepolSurveyId(stateApp);
	const threshold = selectAppStateThreshold(stateApp);
	const useThreshold = selectAppStateUseThreshold(stateApp);
	const useShadow = selectAppStateUseShadow(stateApp);
	const allRemediationsActions = selectAppStateRemediationActions(stateApp);
	const remediationsActions =
		(allRemediationsActions || {})[primarySurveyId] || {};

	const customGroups = selectAppStateCustomGroups(stateApp);
	const useInterpolatedDepol = selectAppStateUseInterpolatedDepol(stateApp);
	const useNormalizedDepol = selectAppStateUseNormalizedDepol(stateApp);

	const seriesVisibility = selectAppStateSeriesVisibility(stateApp) || {};

	if (primarySurveyId) {
		// @todo  - find a better place for this transform to live
		// @note - it should likely live in app state actions or chart settings actions
		dispatch(
			addChartSettings(chartId, {
				...createInitialChartSettings(),
				chartId,
				thresholds: [threshold],
				useThreshold,
				useShadow,
				useInterpolatedDepol,
				useNormalizedDepol,
				primarySurveyId,
				depolSurveyId,
				seriesVisibility,
				boundaryXYMinMax: selectDataXYMinMax(stateApp, chartId)
			})
		);
		dispatch(thunkClearCustomGroupRanges(chartId));
		dispatch(thunkComputeBelowCriterions(chartId));
		dispatch(thunkSetCustomGroupRanges(chartId, customGroups));
		dispatch(setRemediationsActions(chartId, remediationsActions || {}));
	}
};

export default { loadChartSettings };
